import { useCallback, useMemo } from "react";
import { MakeApiCall } from "../apis";

const pad = (value) => String(value).padStart(2, "0");

/** Super Admin role id in API user_type (see config Types). */
const SUPER_ADMIN_USER_TYPE = 1;

const isSuperAdminInitiator = (userData) => {
  if (userData?.user?.switcher_user?.user_type === SUPER_ADMIN_USER_TYPE) {
    return true;
  }
  if (userData?.admin?.user?.user_data?.user_type === SUPER_ADMIN_USER_TYPE) {
    return true;
  }
  if (
    !userData?.user?.switcher_user &&
    userData?.user?.user_data?.user_type === SUPER_ADMIN_USER_TYPE
  ) {
    return true;
  }
  return false;
};

export const formatToHubSpotDateTime = (date = new Date()) => {
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
    date.getDate()
  )} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(
    date.getSeconds()
  )}`;
};

export const useHubSpotSync = (userData) => {
  const viewBySuperAdmin = useMemo(
    () => isSuperAdminInitiator(userData),
    [
      userData?.user?.switcher_user?.user_type,
      userData?.admin?.user?.user_data?.user_type,
      userData?.user?.user_data?.user_type,
    ]
  );

  const syncProperties = useCallback(
    (properties = {}) => {
      const base =
        properties && typeof properties === "object" && !Array.isArray(properties)
          ? properties
          : {};

      const payload = viewBySuperAdmin
        ? { ...base, is_view_by_admin: 1 }
        : base;

      // Fire-and-forget background sync to keep the UI responsive.
      Promise.resolve().then(async () => {
        try {
          await MakeApiCall(
            "hubspot-engagement/sync-properties",
            "post",
            payload,
            true,
            {},
            userData?.token
          );
        } catch (error) {
          console.error("HubSpot engagement sync failed:", error);
        }
      });
    },
    [userData?.token, viewBySuperAdmin]
  );

  const syncActionTimestamp = useCallback(
    (actionKey, date = new Date()) => {
      if (!actionKey || typeof actionKey !== "string") return;
      syncProperties({ [actionKey]: formatToHubSpotDateTime(date) });
    },
    [syncProperties]
  );

  const syncActionCount = useCallback(
    (actionKey, count = 1) => {
      if (!actionKey || typeof actionKey !== "string") return;
      const parsedCount = Number.isFinite(Number(count)) ? Number(count) : 1;
      syncProperties({ [actionKey]: parsedCount });
    },
    [syncProperties]
  );

  return { syncProperties, syncActionTimestamp, syncActionCount };
};

